import React from "react";
import { useParams } from "react-router-dom";
import AppTable from "components/Shared/AppTable";
import { localizeDateTimeShort } from "utils/dateFormats";
import { useTablePagination } from "hooks";
import { useLazyGetLeadStatusLogQuery } from "store/services/vendorLeadApi";

const VendorLeadStatusLogTab = () => {
    const { id } = useParams();
    const { currentPage, perPage, handlePageChange, handlePerRowsChange } =
        useTablePagination();

    const [fetchStatusLog, { data: logRes, isLoading, isFetching }] =
        useLazyGetLeadStatusLogQuery();

    React.useEffect(() => {
        fetchStatusLog({ id, page: currentPage, limit: perPage });
    }, [id, currentPage, perPage, fetchStatusLog]);

    const columns = [
        {
            name: "Changed By",
            selector: (row) => row?.changedBy?.name,
            cell: (row) => (
                <div className="line-clamp-1">
                    {row?.changedBy?.name || "System"}
                </div>
            ),
            minWidth: "160px",
        },
        {
            name: "From",
            selector: (row) => row?.fromStatus,
            cell: (row) => (
                <div className="line-clamp-1">
                    {row?.fromStatus || "—"}
                </div>
            ),
            minWidth: "130px",
        },
        {
            name: "To",
            selector: (row) => row?.toStatus,
            cell: (row) => (
                <div className="line-clamp-1 font-medium">
                    {row?.toStatus || "—"}
                </div>
            ),
            minWidth: "130px",
        },
        {
            name: "Changed At",
            selector: (row) => row?.createdAt,
            cell: (row) => (
                <div className="line-clamp-1">
                    {row?.createdAt ? localizeDateTimeShort(row.createdAt) : "N/A"}
                </div>
            ),
            minWidth: "180px",
        },
    ];

    return (
        <AppTable
            columns={columns}
            data={logRes?.data}
            progressPending={isLoading || isFetching}
            paginationTotalRows={logRes?.totalSize ?? 0}
            paginationPerPage={perPage}
            paginationDefaultPage={currentPage}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
        />
    );
};

export default VendorLeadStatusLogTab;